import { motion } from "framer-motion";
import NextArrow from "@/components/landing/NextArrow";
import { toast } from "sonner";
import { MonitorSmartphone, FileText, Bell, Lock } from "lucide-react";

const features = [
  { icon: FileText, title: "Expediente digital", desc: "Documentos, acuerdos y promociones de tu caso en un solo lugar." },
  { icon: Bell, title: "Alertas en tiempo real", desc: "Notificaciones inmediatas de cada movimiento procesal." },
  { icon: MonitorSmartphone, title: "Acceso multiplataforma", desc: "Consulta desde cualquier dispositivo, en cualquier momento." },
  { icon: Lock, title: "Seguridad de nivel bancario", desc: "Tu información protegida con cifrado de extremo a extremo." },
];

const PortalSection = () => (
  <section id="plataforma" className="screen py-16 md:py-20 bg-[var(--gm-deep)] text-[var(--gm-on-deep)] overflow-hidden" data-testid="portal-section">
    <div
      className="absolute inset-0 opacity-[0.07] pointer-events-none"
      style={{
        backgroundImage:
          "linear-gradient(rgba(246,244,238,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(246,244,238,0.4) 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
    />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
      <div className="grid lg:grid-cols-12 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-6"
        >
          <p className="text-xs tracking-[0.3em] uppercase font-semibold text-[var(--gm-accent)] mb-6">
            Plataforma digital · powered by JADA
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
            Tu caso, <span className="italic text-[var(--gm-accent)]">visible las 24 horas</span>
          </h2>
          <p className="mt-8 text-base font-light text-[var(--gm-faint)] leading-relaxed max-w-lg">
            El despacho opera sobre JADA, una plataforma legal-tech donde nuestros abogados
            gestionan expedientes y nuestros clientes consultan el avance de sus asuntos
            sin llamadas ni esperas.
          </p>
          <div className="mt-12 flex flex-wrap gap-5">
            <button
              onClick={() => toast.info("El portal JADA estará disponible próximamente. Te avisaremos por correo.")}
              className="px-8 py-4 rounded-full text-sm tracking-wide bg-[var(--gm-accent)] text-white transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(59,130,246,0.35)]"
              data-testid="portal-login-clientes-btn"
            >
              Portal de clientes
            </button>
            <button
              onClick={() => toast.info("El acceso para abogados estará disponible próximamente.")}
              className="px-8 py-4 rounded-full text-sm tracking-wide border border-[var(--gm-line-on-deep)] transition-colors duration-300 hover:border-[var(--gm-accent)] hover:text-[var(--gm-accent)]"
              data-testid="portal-login-abogados-btn"
            >
              Acceso para abogados
            </button>
          </div>
        </motion.div>

        <div className="lg:col-span-6 grid sm:grid-cols-2 gap-5">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -6 }}
              className="backdrop-blur-xl bg-white/[0.06] border border-white/10 rounded-sm p-8"
              data-testid={`portal-feature-${i}`}
            >
              <f.icon className="w-6 h-6 text-[var(--gm-accent)] mb-5" strokeWidth={1.5} />
              <h3 className="font-serif-display text-xl font-medium">{f.title}</h3>
              <p className="mt-3 text-sm font-light text-[var(--gm-faint)] leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
        <NextArrow to="contacto" oscuro />
</section>
);

export default PortalSection;
